import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const StepTabletLineIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="161"
      height="586"
      viewBox="0 0 161 586"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.5"
        d="M144.804 0.169678C152.5 62 -17.8433 71.4736 3.00031 95C23.8439 118.526 21.9014 141.85 17 171C9.43307 203.762 165.985 218.91 159.5 270C143 400 5.74029 368.504 3.00031 432.5C3.00031 489.5 55.0005 565.5 113.5 585.5"
        stroke="#0C365C"
      />
    </svg>
  );
};

export default StepTabletLineIcon;
